/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 ..\Campus.glb --transform 
Files: ..\Campus.glb [48.66MB] > C:\Users\fabia\OneDrive\Dokumente\Dateien\To-Do\IDPA_BM-Campus\glb\gltfjsx\Campus-transformed.glb [2.05MB] (96%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function CampusModel(props) {
  const { nodes, materials } = useGLTF('/models/campus-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Campus.geometry} material={materials['Benutzerdefiniert (4)']} position={[-10, 0, -18.5]} rotation={[Math.PI / 2, 0, 0]} scale={0.001} />
    </group>
  )
}

useGLTF.preload('/models/campus-transformed.glb')
